export const DEFAULT_URL_ARGUMENTS = "?lead_via_main_website=true";
export const PARTNER_URL_ARGUMENTS = "lead_via_partner_website=true";
export const REFERRAL_ARGUMENTS = "lead_via_referral=true";
export const WEBINAR_LEAD_ARGUMENTS = "lead_via_webinar=true";

export const SCRIPT_LOAD_DELAY = 5000;

export const DEFAULT_API_ERROR_MESSAGE =
  "Something went wrong, Please try again.";
